export default __webpack_public_path__ + "static/media/for developers-09.137ad1c8.svg";